<script setup>
import { computed, watch, onMounted, onBeforeUnmount } from 'vue'
import { useProjectStore } from '@/stores/project'
import { useSearchStore } from '@/stores/search'
import { useRoute } from 'vue-router'

const route = useRoute()

const projectStore = useProjectStore()

const searchStore = useSearchStore()
const project = computed(() => projectStore.current)
const projectId = computed(() => parseInt(route.params.project_id))
const hideLayout = computed(() =>
  ['ProjectCreate', 'ProjectHome', 'ProjectMonitoring', 'ProjectAlerts', 'ProjectImagery', 'ProjectChat', 'CreateTemplate', 'EditTemplate'].includes(route.name) ||
  route.matched.some(r => r.name === 'ProjectSettings')
)

const resetSelected = () => {
  projectStore.setCurrent(null)
  searchStore.removeParam({ key: 'project_id' })
}

onMounted(async () => {
  await projectStore.fetchProject(projectId.value)
})

onBeforeUnmount(() => {
  resetSelected()
})

watch(() => project.value, (value) => {
  if (value) {
    projectStore.setLastSelected(value)
  }
})

// Watch for route changes to fetch new project when project_id changes
watch(() => projectId.value, async (newProjectId, oldProjectId) => {
  if (newProjectId && newProjectId !== oldProjectId) {
    await projectStore.fetchProject(newProjectId)
  }
})
</script>

<template>
  <div v-if="!hideLayout">
    <div class="p-3" :key="projectId">
      <router-view></router-view>
    </div>
  </div>
  <router-view v-else></router-view>
</template>
